<template>
  <p
    :class="
      contentToTailwindClasses({
        fontSize,
        textColor,
      })
    "
    class="hyphens-auto whitespace-pre-wrap font-medium"
  >
    {{ text }}
  </p>
</template>

<script setup>
import { contentToTailwindClasses } from "~/utils/helper/tailwind";

defineProps(["text", "fontSize", "textColor"]);
</script>
